export default __webpack_public_path__ + "static/titre-b98c99bc2e25c28d46f28bcc43770b81.webp";